import { isEmpty } from "ramda";
import { getAccessToken } from ".";

export const checkIsLoggedIn = () => {
  const accessToken = getAccessToken();
  
  return !isEmpty(accessToken)
};
